export enum IntegrationFormFlow {
  Connect = 'Connect',
  Disconnect = 'Disconnect',
}
